<template><div><h1 id="artikel-nach-gewahrten-rabatten" tabindex="-1"><a class="header-anchor" href="#artikel-nach-gewahrten-rabatten"><span>Artikel nach gewährten Rabatten</span></a></h1>
<p>Artikel nach gewährten Rabatten</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung erstellt eine Liste aller in einem bestimmten Zeitraum verkauften Artikel und zeigt, welche Rabatte in den Aufträgen gewährt wurden. Die Liste ist sortiert nach Verkaufspreis in absteigender Reihenfolge.</p>
<p>Pfad: <code v-pre>Logistik → Auswertungen → Artikel nach gewährten Rabatten</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>verkaufte Artikel von</dt>
<dd>Datum, inklusive, leer = unbegrenzt</dd>
<dt>verkaufte Artikel bis</dt>
<dd>Datum, inklusive, leer = unbegrenzt</dd>
<dt>Ausgabe</dt>
<dd>Standard (Drucker: A4-Portrait)</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>ArtNum</td>
<td>Artikelnummer</td>
</tr>
<tr>
<td>Artikelbezeichnung</td>
<td>Artikelbezeichnung</td>
</tr>
<tr>
<td>VPreis</td>
<td>Verkaufspreis gemäss Artikelstamm</td>
</tr>
<tr>
<td>R%(VPreis)</td>
<td>durchschnittlich gewährter Rabatt auf Verkaufspreis, in Prozent</td>
</tr>
<tr>
<td>R%(EPreis)</td>
<td>durchschnittlich gewährter Rabatt auf Einzelpreis, in Prozent (Einzelpreis = Verkaufspreis aus der einzelnen Auftragsposition, d.h. der zum Zeitpunkt der Auftragsfakturierung gültige Verkaufspreis)</td>
</tr>
<tr>
<td>R%max</td>
<td>Maximal gewährter Rabatt pro Artikel</td>
</tr>
</tbody>
</table>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line"></span>
<span class="line">Datenausgabe                                07.07.1998 12:54:39 pav  Seite     0</span>
<span class="line"></span>
<span class="line">Zeitraum: von  01.01.1998 bis 30.06.1998 Artikel nach gewährten Rabatten</span>
<span class="line">ArtNr.  Artikelbezeichnung                   VPreis R%(VPreis) R%(EPreis)  R%max</span>
<span class="line">------- ---------------------------------- -------- ---------- ---------- ------</span>
<span class="line">POM     PULLOVER NATURE M     6,5             97.00      30.00      30.00  30.00</span>
<span class="line">AIF     IFEROUANE-KREUZ       6,5             62.00      15.00      15.00  15.00</span>
<span class="line">0211.00 Kinder-Besteck, Chromnickelstahl      60.00       0.00       0.00   0.00</span>
<span class="line">0050.05 Vogelpfeife 'Blaumeise'               32.00       8.89       8.89  20.00</span>
<span class="line">K7      HELVETAS-Kalender 97  6,5             32.00      30.00      30.00  30.00</span>
<span class="line">0077.00 Utensilo Leder, dunkel                29.00       0.00       0.00   0.00</span>
<span class="line">.</span>
<span class="line">.</span>
<span class="line"></span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div><p>Lesebeispiel: Der Artikel Vogelpfeife 'Blaumeise' hat einen aktuellen Verkaufspreis im Artikelstamm von Fr. 32.--. Im ersten Halbjahr 1998 wurden durchschnittlich 8.89% Rabatt gegenüber dem Verkaufspreis gewährt. Der Verkaufspreis war in dieser Zeit unverändert, denn auch der durchschnittliche Rabatt aus den Auftragseinzelpositionen liegt bei 8.89%. Der höchste, in einem Auftrag gewährte Rabatt (innerhalb des Auswertungszeitraums) für diesen Artikel beträgt 20%.</p>
</div></template>


